import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    '@keyframes fadeInWidgets': {
        '0%': {
            transform: 'translateY(-30px)',
            transition: 'transform 2s',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    animateOnCurtainClosed: {
        opacity: 0,
        animation: '$fadeInWidgets 1s forwards 1.5s',
    },
    bodyText: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        fontWeight: 'normal',
        lineHeight: 1.71,
        opacity: 0.8,
        color: theme.colors.text.light,
        whiteSpace: 'pre-line',
    },
}))
